import { requestEmailChange as requestEmailChangeCallable } from '@griply/services';
import { AuthFlow, AuthFlowError, ChangeEmailErrorKind } from '@griply/types';
import {
  getChangeEmailErrorKind,
  getChangeEmailFailureKind,
} from '@griply/utils';
import { EmailAuthProvider, reauthenticateWithCredential } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';

import { getAuthentication, getFunctions, reportAuthError } from './helpers';

// Nothing changes yet: the backend mails the new address a link, and only that link moves the account.
export const requestEmailChange = async (
  newEmail: string,
  password: string,
): Promise<void> => {
  const auth = await getAuthentication();
  const user = auth.currentUser;
  if (!user?.email) {
    const error = new AuthFlowError(ChangeEmailErrorKind.Unknown);
    reportAuthError(error, AuthFlow.ChangeEmail);
    throw error;
  }

  let outcome: unknown;
  try {
    await reauthenticateWithCredential(
      user,
      EmailAuthProvider.credential(user.email, password),
    );
    ({ outcome } = await requestEmailChangeCallable({
      functions: getFunctions(),
      httpsCallable,
      newEmail,
    }));
  } catch (error) {
    const kind = getChangeEmailFailureKind(error);
    if (kind === ChangeEmailErrorKind.Unknown) {
      reportAuthError(error, AuthFlow.ChangeEmail);
    }
    throw new AuthFlowError(kind, { cause: error });
  }

  const kind = getChangeEmailErrorKind(outcome);
  if (!kind) {
    return;
  }
  if (kind !== ChangeEmailErrorKind.Unknown) {
    throw new AuthFlowError(kind);
  }
  const refusal = new Error(
    'users-requestEmailChange refused a request the app made',
  );
  reportAuthError(refusal, AuthFlow.ChangeEmail, { outcome });
  throw new AuthFlowError(kind, { cause: refusal });
};
